import { defineTenant } from './theme/config'
export default defineTenant({
  brand: {
    name: 'CIMB',
    logo: {
      light:
        'https://cdn.magicpatterns.com/uploads/tAxFd7mVJpFSMq5D78k69t/cimb-general_Logo.svg',
      dark: 'https://cdn.magicpatterns.com/uploads/tAxFd7mVJpFSMq5D78k69t/cimb-general_Logo.svg',
    },
    favicon:
      'https://cdn.magicpatterns.com/uploads/tAxFd7mVJpFSMq5D78k69t/cimb-general_Logo.svg',
  },
  locale: {
    default: 'en-US',
    supported: ['en-US'],
    timezone: 'Asia/Kuala_Lumpur',
  },
  currency: {
    code: 'MYR',
  },
})
